<template>
  <div class="login">
    <v-card>
      <v-tabs v-model="type" grow color="pink">
        <v-tab>會員</v-tab>
        <v-tab>主播</v-tab>
      </v-tabs>
      <v-tabs-items v-model="type">
        <v-tab-item>
          <div class="py-8 px-10">
            <h3 class="mb-6 text-center">立即登入</h3>
            <!-- <span>Email</span>
            <v-text-field outlined dense autofocus v-model="email"></v-text-field> -->
            <span>手機號碼</span>
            <v-text-field outlined dense autofocus v-model="tel"></v-text-field>
            <span>密碼</span>
            <v-text-field outlined dense type="password" v-model="password" @keydown.enter="login"></v-text-field>
            <router-link to="/forget">忘記密碼?</router-link>
            <v-btn dark rounded block height="40" color="pink" class="mb-2 mt-4" @click="login">登入</v-btn>
            <div class="caption text-center">
              繼續登入，代表您同意
              <a href="/terms" target="_blank">服務條款</a>
              及
              <a href="/policy" target="_blank">隱私權政策</a>
            </div>
            <v-btn dark rounded block height="40" class="my-2" to="/register">立即註冊</v-btn>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="pt-8 pb-8 px-10">
            <h3 class="mb-6 text-center">主播登入</h3>
            <span>手機號碼</span>
            <v-text-field outlined dense v-model="tel"></v-text-field>
            <span>密碼</span>
            <v-text-field outlined dense type="password" v-model="password" @keydown.enter="sellerLogin"></v-text-field>
            <router-link to="/forget">忘記密碼?</router-link>
            <v-btn dark rounded block height="40" color="pink" class="mb-2 mt-4" @click="sellerLogin">登入</v-btn>
            <div class="caption text-center">
              繼續登入，代表您同意
              <router-link to="/terms">服務條款</router-link>
            </div>
            <v-btn rounded block height="40" class="my-2" to="/register" :disabled="true">註冊成為主播</v-btn>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>    
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      type: '',
      email: '',
      tel: '',
      password: '',
    }
  },
  created() {
    this.type = this.$route.query.type == 'seller' ? 1 : 0
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['all_verified']),
    formIsValid() {
      return this.tel && this.password
    }
  },
  methods: {
    login() {
      if(!this.formIsValid) {
        return
      }
      this.axios.post('/member/login', {
        tel: this.tel,
        password: this.password
      }).then(response => {
        let token = `Bearer ${response.data.access_token}`
        this.$store.dispatch('user/login', token)
        this.$store.dispatch('user/getUserInformation').then(_ => {
          if(this.all_verified) {
            this.$store.dispatch('shoppingCart/getShoppingCartProducts')
            this.$store.dispatch('user/getBans')
            this.$store.dispatch('user/getFollowList')
            this.$store.dispatch('user/getBlockList')
            this.$store.dispatch('user/getPurchaseID')
            this.$store.dispatch('user/getLikeID')
          }
          this.$func.goBack()
        })
      }).catch(() => {
        this.$root.$emit('alert', 'error', '登入失敗')
        this.password = ''
      })
    },
    sellerLogin() {
      this.axios.post('/portal/login', {
        tel: this.tel,
        password: this.password
      }).then(response => {
        let token = `Bearer ${response.data.access_token}`
        this.$store.dispatch('seller/login', token)
        this.$router.push('/portal/dashboard')
      }).catch(() => {
        this.$root.$emit('alert', 'error', '登入失敗')
        this.password = ''
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .v-card {
    width: 400px;
    a:not(.v-btn) {
      color: unset !important;
      text-decoration: underline !important;
      font-size: 12px;
    }
    span {
      font-size: 12px;
    }
    .v-text-field__details {
      display: none;
    }
  }
}
</style>